import React, { useContext, useState } from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material'
import constants from './util/constants'
import { ConfigContext } from './App'

const toTitleCase = (str) => {
  if (str === 'org') return 'Organization'
  str = str.replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2')
  str = str.replace(/^./, (match) => match.toUpperCase())
  return str
}

const AutoForm = ({ formContext, errors }) => {
  const context = useContext(formContext)
  const contextLogin = useContext(ConfigContext)
  const [id, setId] = useState(0)
  let renderFields = []
  let fullwidthStyle = { gridColumn: 'span 2' }

  context.fields.forEach((field) => {
    if (field.field_name !== 'disclaimer') {
      if (!Object.prototype.hasOwnProperty.call(context.state, field.field_name)) {
        if (contextLogin.params[field.field_name]) {
          context.state[field.field_name] = contextLogin.params[field.field_name]
        } else {
          context.state[field.field_name] = ''
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(field, 'answers') ||
        Object.prototype.hasOwnProperty.call(field, 'options')
      ) {
        if (field.field_name === 'state') {
          if (context.state.country !== 'US') {
            if (contextLogin.params.country !== 'US') {
              return
            }
          }
        }
        renderFields.push(
          <FormControl
            variant='filled'
            style={constants.fullWidthFields.includes(field.field_name) ? fullwidthStyle : {}}
            key={'form' + field.field_name}
            required={field.required}
            error={errors[field.field_name]}
          >
            <InputLabel error={errors[field.field_name]}>
              {toTitleCase(field.field_name.replaceAll('_', ' '))}
            </InputLabel>
            <Select
              defaultValue={contextLogin.params[field.field_name]}
              value={context.state[field.field_name]}
              error={errors[field.field_name]}
              onChange={(event) => {
                context.state[field.field_name] = event.target.value
                if (field.field_name === 'country') {
                  context.state.state = event.target.value === 'US' ? '' : 'Other'
                }
                setId(id + 1)
              }}
            >
              {field.options
                ? field.options.map((item, index) => {
                    return (
                      <MenuItem value={item.key} key={field.field_name + index}>
                        {item.value}
                      </MenuItem>
                    )
                  })
                : field.answers.map((item, index) => (
                    <MenuItem value={item} key={field.field_name + index}>
                      {item}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        )
      } else {
        renderFields.push(
          <TextField
            defaultValue={context.state[field.field_name]}
            label={toTitleCase(field.field_name.replaceAll('_', ' '))}
            required={field.required}
            variant='filled'
            style={constants.fullWidthFields.includes(field.field_name) ? fullwidthStyle : {}}
            key={field.field_name}
            error={errors[field.field_name]}
            onChange={(event) => {
              context.state[field.field_name] = event.currentTarget.value
            }}
          />
        )
      }
    } else {
      if (!Object.prototype.hasOwnProperty.call(context.state, field.field_name)) {
        context.state[field.field_name] = false
      }
    }
  })

  context.questions.forEach((question) => {
    let response = context.state.responses.find((response) => response.title === question.title)
    if (!response) {
      let newQuestion = {
        title: question.title,
        value: ''
      }
      context.state.responses.push(newQuestion)
      response = newQuestion
    }
    switch (question.type) {
      case 'single_dropdown':
        renderFields.push(
          <FormControl
            variant='filled'
            style={fullwidthStyle}
            key={'form' + question.title}
            required={question.required}
            error={errors[question.title]}
          >
            <InputLabel>{question.title}</InputLabel>
            <Select
              value={response.value}
              error={errors[question.title]}
              onChange={(event) => {
                response.value = event.target.value
                setId(id + 1)
              }}
            >
              {question.answers.map((answer, index) => (
                <MenuItem value={answer} key={question.title + index}>
                  {answer}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
        break
      case 'single_radio':
        if (!response.value) response.value = question.answers[0]
        renderFields.push(
          <FormControl component='fieldset' style={fullwidthStyle} required={question.required} key={question.title}>
            <FormLabel component='legend'>{question.title}</FormLabel>
            <RadioGroup
              name={question.title}
              value={response.value}
              onChange={(event) => {
                response.value = event.currentTarget.value
                setId(id + 1)
              }}
            >
              {question.answers.map((answer) => (
                <FormControlLabel value={answer} control={<Radio />} label={answer} key={answer} />
              ))}
            </RadioGroup>
          </FormControl>
        )
        break
      default:
        renderFields.push(
          <TextField
            label={question.title}
            required={question.required}
            variant='filled'
            style={fullwidthStyle}
            key={question.title}
            error={errors[question.title]}
            onChange={(event) => {
              response.responseText = event.currentTarget.value
            }}
          />
        )
        break
    }
  })

  renderFields.push(
    <p key={'terms'} style={fullwidthStyle}>
      By registering, I agree to the
      <a href='https://gemvision.com/privacy' target='_blank' rel='noopener noreferrer' title='privacy policy'>
        {' '}
        Privacy Policy
      </a>
      ,{' '}
      <a href='https://zoom.us/privacy' target='_blank' rel='noopener noreferrer' title='privacy solicy'>
        Privacy Statement
      </a>{' '}
      and
      <a href='https://zoom.us/terms' target='_blank' rel='noopener noreferrer' title='terms of service'>
        {' '}
        Terms of Service
      </a>
    </p>
  )

  return (
    <FormControl
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0 .75rem'
      }}
    >
      {renderFields}
    </FormControl>
  )
}

export default AutoForm
